import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SwitchToggle, Typography } from '@klarna/bubble-ui';
import { Message } from 'mage-i18n';

import { generateCyElemId } from 'moet-test-utils/cypress/utils';

const SwitchToggleComponent = ({
  messagePath,
  customStyle = {},
  idForTestSuite = undefined,
  tabIndex = 0,
  ...props
}) => (
  <div style={customStyle}>
    <SwitchToggle
      rightAligned
      tabIndex={tabIndex}
      {...generateCyElemId(idForTestSuite, window)}
      {...props}
    >
      <Typography
        textToken="text-style/text/super-paragraphs/body/medium"
        colorToken="colors/text/neutral"
      >
        <Message path={messagePath} />
      </Typography>
    </SwitchToggle>
  </div>
);

SwitchToggleComponent.propTypes = {
  messagePath: PropTypes.string.isRequired,
  customStyle: PropTypes.object,
  idForTestSuite: PropTypes.string,
  tabIndex: PropTypes.number,
};

export default SwitchToggleComponent;
